import { BaseLayout } from './components';

export const RuntimeEnvironments = () => {
  return <BaseLayout />;
};
export default RuntimeEnvironments;
